import { createActions } from 'redux-actions';

import { ENDPOINTS_SEARCH } from '../../config';
import { defaultErrorMessage, globalFetch, isAction } from '../../shared/helpers/fetch-helper';
import { logErrorService } from '../../shared/services';

export const {
  requestSearchById,
  responseSearchSuccessById,
  responseSearchSuccess,
  responseSearchFailure,
  requestSearch,
  searchChangeFilters,
  searchChangeDataQuery,
  searchClean,
  responseSearchFailureById,
  currentScrollPosition,
  cleanSearchPage,
} = createActions(
  {
    REQUEST_SEARCH_BY_ID: (id: string, page: any) => ({ id, page }),
    RESPONSE_SEARCH_SUCCESS_BY_ID: (id: string, data: any) => ({ id, data }),
    RESPONSE_SEARCH_SUCCESS: (data: any, queryTerm: string, queryFilters: string[], count: number) => ({
      data,
      queryTerm,
      queryFilters,
      count,
    }),
    RESPONSE_SEARCH_FAILURE: (queryTerm: string, queryFilters: string[]) => ({ queryTerm, queryFilters }),
  },
  'REQUEST_SEARCH',
  'SEARCH_CHANGE_FILTERS',
  'SEARCH_CHANGE_DATA_QUERY',
  'SEARCH_CLEAN',
  'RESPONSE_SEARCH_FAILURE_BY_ID',
  'CURRENT_SCROLL_POSITION',
  'CLEAN_SEARCH_PAGE'
);

const countResults = (data: any) => {
  let results: number = 0;

  Object.keys(data).forEach((filter: any) => {
    if (data[filter].hasOwnProperty('count')) {
      const count: number = data[filter].count;
      results = results + count;
    }
  });

  return results;
};

export const searchData =
  (queryTerm: string, queryFilters: string[], filterOptions: string = '&type=reference%1FtutorialPage%1Fvideo%1FrecommendedReading') =>
  async (dispatch: any): Promise<object> => {
    dispatch(requestSearch());

    return globalFetch(
      `${ENDPOINTS_SEARCH.search}?query=${queryTerm}${filterOptions}`,
      {
        method: 'GET',
        credentials: 'include',
      },
      dispatch,
      () => dispatch(responseSearchFailure(queryTerm, queryFilters))
    )
      .then(async (json): Promise<object> => {
        if (isAction(json, 'RESPONSE_SEARCH_FAILURE')) {
          return json;
        }

        return dispatch(responseSearchSuccess(json, queryTerm, queryFilters, countResults(json)));
      })
      .catch((err: any) => {
        defaultErrorMessage(dispatch);
        logErrorService(err, err);

        return dispatch(responseSearchFailure());
      });
  };

export const searchDataById = (id: string, pageNumber: number, offset: number, queryTerm: string) => async (dispatch: any) => {
  dispatch(requestSearchById(id, pageNumber));

  return globalFetch(
    `${ENDPOINTS_SEARCH.search}?query=${queryTerm}&type=${id}&offset=${offset}`,
    {
      method: 'GET',
      credentials: 'include',
    },
    dispatch,
    () => dispatch(responseSearchFailureById(id))
  )
    .then(json => {
      if (isAction(json, 'RESPONSE_SEARCH_FAILURE_BY_ID')) {
        return json;
      }

      return dispatch(responseSearchSuccessById(id, json));
    })
    .catch((err: any) => {
      defaultErrorMessage(dispatch);
      logErrorService(err, err);

      return dispatch(responseSearchFailureById(id));
    });
};
